import React, { useEffect } from "react";
import { Header } from "../components/site/Header";
import { Hero } from "../components/site/Hero";
import { Marquee } from "../components/site/Marquee";
import { About } from "../components/site/About";
import { Collections } from "../components/site/Collections";
import { ArtOfIttar } from "../components/site/ArtOfIttar";
import { PujaEssentials } from "../components/site/PujaEssentials";
import { MukutShringar } from "../components/site/MukutShringar";
import { CustomDress } from "../components/site/CustomDress";
import { WhyChooseUs } from "../components/site/WhyChooseUs";
import { Featured } from "../components/site/Featured";
import { Testimonials } from "../components/site/Testimonials";
import { InstagramGallery } from "../components/site/InstagramGallery";
import { Contact } from "../components/site/Contact";
import { Footer } from "../components/site/Footer";
import { FloatingWhatsApp } from "../components/site/FloatingWhatsApp";
import { useLang } from "../i18n/LanguageContext";

export default function Home() {
  const { lang } = useLang();

  useEffect(() => {
    document.documentElement.lang = lang;
    document.title =
      lang === "hi"
        ? "निकुंज इत्र वाले | पारंपरिक भारतीय इत्र, पूजा सामग्री व ठाकुर जी पोशाक"
        : "Nikunj Ittar Wale | Traditional Indian Ittar, Puja Essentials & Thakur Ji Poshak";
    const desc =
      lang === "hi"
        ? "निकुंज इत्र वाले — वृन्दावन का प्रीमियम भारतीय विरासत बुटीक। शुद्ध इत्र, चंदन, पूजा सामग्री, ठाकुर जी, राधा रानी व लड्डू गोपाल पोशाक, मुकुट व श्रृंगार तथा कस्टम पोशाक।"
        : "Nikunj Ittar Wale — a premium Indian heritage boutique from Vrindavan offering pure ittar, chandan, puja essentials, Thakur Ji, Radha Rani & Laddu Gopal poshak, mukut, shringar and customised deity dresses.";
    let meta = document.querySelector('meta[name="description"]');
    if (!meta) { meta = document.createElement("meta"); meta.name = "description"; document.head.appendChild(meta); }
    meta.content = desc;
  }, [lang]);

  return (
    <>
      <Header />
      <main>
        <Hero />
        <Marquee />
        <About />
        <Collections />
        <ArtOfIttar />
        <PujaEssentials />
        <MukutShringar />
        <CustomDress />
        <WhyChooseUs />
        <Featured />
        <Testimonials />
        <InstagramGallery />
        <Contact />
      </main>
      <Footer />
      <FloatingWhatsApp />
    </>
  );
}
